import type { ColumnDef } from './types.js';

export function sortRows<T>(
    rows: T[],
    columns: Array<ColumnDef<T>>,
    key: string,
    direction: 'asc' | 'desc',
): T[] {
    const col = columns.find((c) => c.key === key);
    if (!col) return rows;
    const dir = direction === 'asc' ? 1 : -1;
    return [...rows].sort((a, b) => {
        const va = col.accessor(a);
        const vb = col.accessor(b);
        if (col.type === 'text') {
            return dir * String(va ?? '').localeCompare(String(vb ?? ''));
        }
        return dir * (((va as number) ?? -Infinity) - ((vb as number) ?? -Infinity));
    });
}
